import * as React from 'react';

import { ListPackagesProps } from '../../components/list/packages';
import ListPackage from '../../components/list/package';
import ListSuperPackage from '../../components/list/super-package';

import { PackageType } from '../../classes/package-listing';

const ListPackagesView: React.StatelessComponent<ListPackagesProps> = props => {
    return (
        <ul className="stack-lg stack-border">
            {
                props.packages.map(pkg =>
                    pkg.packageType == PackageType.Super ?
                        <ListSuperPackage key={`${pkg.id}`} package={pkg} />
                        : <ListPackage key={`${pkg.id}`} package={pkg} />)
            }
        </ul>
    )
}

export default ListPackagesView;